import {
    http,
    httpToken
} from './http-service';
import jwt from 'jsonwebtoken';

export function register(user) {
    return http().post('/register', user);
}

export function login(user) {
    return http().post('/login', user);
}

export function logout() {
    return httpToken().post('/logout');
}

export function isLoggedIn() {
    const token = localStorage.getItem('vue-token');
    return token != null;
}

export function tokenExpiresAt() {
    return httpToken().post('/token-expires');
}

export function getUser() {
    return httpToken().get('/user');
}

export function routeIndexName() {
    return getUser().then(res => {
        switch (res.data.division_id) {
          case 8:
            return 'translate.dashboard';
          default:
            return 'index';
        }
    }).catch(error => {
        return 'index';
    });
}

export function getToken() {
    return jwt.decode(localStorage.getItem('vue-token'));
}

export function setToken(data) {
    const token = jwt.sign({
        user: data
    }, process.env.MIX_API_WEB_TOKEN_KEY);
    localStorage.setItem('vue-token', token);
}

export async function refreshToken() {
    if (isLoggedIn()) {
        const token = getToken();
        try {
            let res = await httpToken().post('/refresh-token', {
                'refresh_token': token.user.refresh_token,
                'remember': token.user.remember,
                'scope': token.user.scope
            });
            if (res.data && res.status === 200) {
                localStorage.removeItem('vue-token');
                setToken(res.data);
            }
        } catch (error) {
            console.log("Can't refresh token.");
            localStorage.removeItem('vue-token');
        }
    }
}
